// キャンバスの編集ビューのブラウザのタブタイトル（document.title）を、表示中のキャンバスの名前に合わせるフック。
// 読み込みが完了してワークスペースを描画している間だけ使う（CanvasRealtimeWorkspace から呼ぶ）。
// アンマウント（読み込みの失敗・キャンバスの切り替え・キャンバスから離れる）で既定のタブタイトルへ戻す。

import { useEffect } from "react";
import { buildCanvasLinkLabel } from "../../lib/canvas-link-clipboard";
import { normalizeCanvasTitle } from "../../lib/canvas-title";

/** 既定のタブタイトル。apps/web/index.html の <title> と同じ文言を保つ（テストで照合する）。 */
export const APP_DOCUMENT_TITLE = "Connect Canvas";

/**
 * キャンバス名（ストアの meta.title。未正規化）から「<表示名>｜Connect Canvas」をタブタイトルへ反映する。
 * 表示名はアプリメニューとリンクのコピーと同じく normalizeCanvasTitle で正規化する。
 *
 * 書き込みは描画の後のエフェクトで、文字列が変わったとき・マウント時・アンマウント時だけ行う。
 * タブタイトルは文書の中に描かれないため、描画を止めて合わせる useLayoutEffect にはしない。
 * React の <title> 要素の描画（document.head への巻き上げ）は使わない。静的 HTML の <title> と 2 つ並ぶと、
 * ブラウザは文書の先頭の要素を使うため、意図した文字列にならない。document.title への代入は、既存の先頭の
 * <title> 要素のテキストを文字列として置き換える（HTML として解釈しないため escape は不要）。
 */
export function useCanvasDocumentTitle(rawTitle: string): void {
  const title = buildCanvasLinkLabel(normalizeCanvasTitle(rawTitle));
  useEffect(() => {
    document.title = title;
    return () => {
      // 直前の値ではなく既定へ戻す。後始末の順序に左右されず、キャンバスの文字列を
      // キャンバス以外の画面へ残さないため。
      document.title = APP_DOCUMENT_TITLE;
    };
  }, [title]);
}
